// Popper's default preventOverflow padding (64) shoves an edge-anchored menu ~48px off its trigger
// (a bottom-start menu drifts right of the left edge; a bottom-end menu drifts left of the right edge).
// Shrink it so the menu sits at its placement. (The spread replaces all modifiers, so re-supply flip/setMobile.)
export const EDGE_MENU_POPPER_PROPS = {
  modifiers: {
    preventOverflow: {padding: 8, boundariesElement: 'viewport' as const},
    flip: {padding: 16},
    setMobile: {enabled: false}
  }
};
